var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('router-link',{staticClass:"flex flex-col items-center px-3",attrs:{"to":{ name: 'SolidifyHome' }}},[_vm._v(" Home ")]),_c('ExecutionTable',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"multi-select-enabled":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }